

import { createRouter, createWebHashHistory } from 'vue-router';
import $http from './services/http.js';
import { currentData, currentId } from './services/store.js';

const routes = [
  { name: 'dashboard', path: '/', component: () => import('./views/Dashboard.vue') },
  { name: 'system', path: '/system/:id?', component: () => import('./views/System.vue') },
  { name: 'request', path: '/request/:id?', component: () => import('./views/Request.vue') },
  { name: 'routing', path: '/routing/:id?', component: () => import('./views/Routing.vue') },
  { name: 'timeline', path: '/timeline/:id?', component: () => import('./views/Timeline.vue') },
  { name: 'events', path: '/events/:id?', component: () => import('./views/Events.vue') },
  { name: 'db', path: '/db/:id?', component: () => import('./views/Database.vue') },
];

const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from) => {
  if (to.path !== '/' && !to.params.id) {
    if (currentId.value) {
      return to.path + '/' + currentId.value;
    } else {
      return '/';
    }
  }

  if (to.params.id) {
    if (currentId.value !== to.params.id) {
      currentId.value = to.params.id;

      const params = new URLSearchParams({
        'path[url]': 'http::systemUri.full',
        'path[status]': 'http::response.status',
      });
      const res = await $http.get('ajax/data?' + params.toString());

      currentData.value = res.data.data;
    }
  }
});

// router.afterEach((to, from, next) => {
//   console.log('After', to);
// });

export default router;
